import {Directive, ElementRef, EventEmitter, Input, NgZone, Output, Renderer2} from '@angular/core';
import {MessageService} from '../providers/message-service';
import {timer} from 'rxjs/observable/timer';
import {debounce} from 'rxjs/operators';

@Directive({
    selector: '[blscroll]'
})
export class BlscrollDirective {

    private element: HTMLElement;

    @Input('blscroll') private blscroll: string;
    @Input('blscroll-id') private id: any;

    @Output('blscroll-run') run: any = new EventEmitter();
    @Output('blscroll-notRun') notRun: any = new EventEmitter();

    constructor(element: ElementRef, public renderer: Renderer2, private messageService: MessageService,
                private ngZone: NgZone) {

        this.element = element.nativeElement || element; // todo: testar se precisa

        this.messageService.get('website.rola').pipe(debounce(() => timer(30)))
            .subscribe(data => this.scrolllReach(data));

    }

    scrolllReach(data) {

        if (!this.blscroll) return;

        if (this.id && data.id != this.id) return;

        if (!data.event) data.event = {scrollTop: 0};

        const offset = 50;

        // compensa o Header
        // const header = this.header.getNativeElement().clientHeight;
        const header = 0;

        const paiTop = (this.element.offsetParent as any || {offsetTop: 0}).offsetTop;

        // cálculo para aplicar efeito e testar star (start poderia ser no ionViewDidLoad, aparentemente sem restrições)
        let animate = data.event.scrollTop + window.innerHeight - offset + header > this.element.offsetTop + paiTop;

        if (this.blscroll == 'run') {
            if (animate)  this.run.emit(this.element);
            if (!animate) this.notRun.emit(this.element);
            return;
        }

        // inicia animacao
        this.ngZone.run(() => {

            if (!animate) {

                this.renderer.addClass(this.element, 'opacity-0');
                this.renderer.removeClass(this.element, 'animated');
                this.renderer.removeClass(this.element, this.blscroll);

                return;
            }

            this.renderer.addClass(this.element, this.blscroll);
            this.renderer.addClass(this.element, 'animated');
            this.renderer.removeClass(this.element, 'opacity-0');

        });

    }

}



// WEBPACK FOOTER //
// ./src/directives/blscroll.ts